export const OFFLINE = 'app/OFFLINE';
export const DEQUEUE_NOTIFICATION = 'app/DEQUEUE_NOTIFICATION';
export const ENQUEUE_NOTIFICATION = 'app/ENQUEUE_NOTIFICATION';
export const ADD_HISTORY = 'app/ADD_HISTORY';
export const PAGE_LOADED = 'app/PAGE_LOADED';
export const MAIN_SIDEBAR_TOGGLE = 'app/MAIN_SIDEBAR_TOGGLE';
export const MAIN_SIDEBAR_OPEN = 'app/MAIN_SIDEBAR_OPEN';
export const MAIN_SIDEBAR_CLOSE = 'app/MAIN_SIDEBAR_CLOSE';
export const WEBSOCKET_CONNECT = 'app/WEBSOCKET_CONNECT';
export const WEBSOCKET_DISCONNECT = 'app/WEBSOCKET_DISCONNECT';
